<script>
import CosmicBackground from "@/components/common/CosmicBackground.vue";
import MainFooter from "@/components/common/MainFooter.vue";
import HomeServiceList from "@/components/HomeServiceList.vue"; // ⭐️ 새로 만든 컴포넌트 불러오기

export default {
  name: "HomePage",
  components: {
    CosmicBackground,
    MainFooter,
    HomeServiceList, // ⭐️ 컴포넌트 등록
  },
};
</script>

<template>
  <div class="home-page">
    <CosmicBackground />

    <main class="content-wrapper">
      
      <section class="hero-section">
        <h1 class="hero-title fade-in-up">
          상상을 현실로 만드는<br>
          <span class="highlight">창의적 여정의 시작</span>
        </h1>
        <p class="hero-desc fade-in-up delay-100">
          말로만랩은 단순한 지식 플랫폼이 아닙니다.<br>
          AI와 결합된 독창적인 도구들로 당신의 호기심을 새로운 가치로 만들어냅니다.
        </p>
        
        <div class="hero-buttons fade-in-up delay-200">
          <router-link to="/journey" class="btn btn-primary glow">
            탐험 시작하기
          </router-link>
          <router-link to="/partnership" class="btn btn-outline">
            비지니스 제휴
          </router-link>
        </div>
      </section>

      <div class="services-container">
        <HomeServiceList />
      </div>

      <MainFooter />

    </main>
  </div>
</template>

<style scoped>
.home-page {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
}

.content-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  padding-bottom: 0px; 
}

* {
  box-sizing: border-box;
}

/* --- Hero Section --- */
.hero-section {
  text-align: center;
  padding: 140px 20px 160px 20px;
  max-width: 900px;
  margin: 0 auto;
  position: relative;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  color: #fff;
  margin-bottom: 40px;
  line-height: 1.2;
}

/* 텍스트 그라데이션 및 애니메이션 */
.highlight {
  background: linear-gradient(
    90deg, 
    #00f3ff, 
    #ffffff, 
    #bc13fe, 
    #00f3ff
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 900;
  animation: shine 4s linear infinite; 
}

@keyframes shine {
  to {
    background-position: 200% center;
  }
}

.hero-desc {
  font-size: 1.2rem; color: #94a3b8; line-height: 1.6;
  margin-bottom: 64px;
}

/* Buttons */
.hero-buttons { display: flex; justify-content: center; gap: 16px; }

.btn {
  padding: 12px 32px; border-radius: 30px; font-weight: 700; font-size: 1rem;
  text-decoration: none; 
  transition: transform 0.2s, box-shadow 0.2s;
  will-change: transform, box-shadow;
}
.btn:hover { transform: translateY(-2px); }

.btn-primary {
  background-color: #ff4757; 
  color: white;
  box-shadow: 0 4px 15px rgba(255, 71, 87, 0.3);
}
.glow:hover { box-shadow: 0 6px 20px rgba(255, 71, 87, 0.5); }

.btn-outline {
  border: 1px solid rgba(255, 255, 255, 0.3); color: #fff;
  background: rgba(255, 255, 255, 0.05);
}
.btn-outline:hover { background: rgba(255, 255, 255, 0.15); border-color: #fff; }

/* ⭐️ 서비스 컨테이너 여백 관리 */
.services-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 80px 20px; 
  content-visibility: auto;
}

/* --- Animation --- */
.fade-in-up {
  opacity: 0; transform: translateY(30px);
  animation: fadeInUp 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
  will-change: opacity, transform;
}
.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }
.delay-300 { animation-delay: 0.3s; }

@keyframes fadeInUp {
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 768px) {
  .hero-title { font-size: 2.5rem; }
  .services-container { padding: 0 16px 60px 16px; }
}
</style>